export const PAGE_TITLE = "My Olympic Homepage";
export const FEATURE_FLAG = "olympics.briefing";
export const CANCEL_SELECTIONS = "Cancel Selections";
export const EDIT_SELECTIONS = "Edit Selections";
export const SEND_FEEDBACK = "Send Feedback";

export const DESCRIPTION_TEXT =
    "Pick your favourite sports to create a customized feed";

export const DEFAULT_PARAMS = {
    name: "myOlympicsWidget",
};
